import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { EnvironmentService } from '@services/environment.service';
import { datadogRum } from '@datadog/browser-rum';

const environmentService = new EnvironmentService();

if (environmentService.DATA_DOG_TOKEN) {
  datadogRum.init({
    applicationId: '6a5d59e7-9997-462e-bcd9-6b5a3bf3e1c4',
    clientToken: environmentService.DATA_DOG_TOKEN,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'lmn-swa-pro-web-admin',
    version: environmentService.DATA_DOG_VERSION,
    env: environmentService.DATA_DOG_ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: 'mask-user-input',
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    allowedTracingUrls: [
      /http:\/\/localhost:.*/,
      /http:\/\/.*\.golmn\.com/,
      /https:\/\/.*\.golmn\.com/,
      /https:\/\/.*groundsguyspro\.com/,
    ],
    excludedActivityUrls: [
      /clientstream\.launchdarkly\.com/,
      /events\.launchdarkly\.com/,
      /www\.facebook\.com/,
      /px\.ads\.linkedin\.com/,
      /clarity\.ms/,
      /data\.pendo\.io/,
    ],
  });
}

if (environmentService.HOST.includes('localhost')) {
  const baseTag = document.createElement('base');
  baseTag.href = '/';
  document.head.appendChild(baseTag);
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
